<template>
    <div class="trainer__list">
        <div class="trainer__list_header">
            <component-induction-message
                :title="'Trainers'"
                :content="'Trainers can be created by assigning the “trainer” role to any user in this workspace. They run your training events. Below you can configure their details and availability.'"
                :link-to="''"
                :theme="'secondary'"
                :route-name="'ebs-trainer-list'"
            ></component-induction-message>
            <view-actions
                v-if="user.isEventCoordinator()"
                :title="$t('ebs.trainers.list.title.trainers')"
                :cancel-button-active="false"
                :submit-button-active="isSecondStageTokenFromOldLMS"
                :submit-button-text="$t('ebs.trainers.list.buttons.createTrainer')"
                @emit-submit="createTrainer"
            />
        </div>
        <div class="trainer__list_main">
            <component-list
                :component-grid="TrainerListGrid"
                :component-table="TrainerListTable"
                :list-view-items="['table', 'grid']"
                :component-table-name="'trainers'"
                :empty-state-title="'Trainers assigned to this workspace will appear here.'"
                :filter-search-queryable="true"
                :get-pagination-getter="'getTrainersPagination'"
                :get-items-getter="'getTrainers'"
                :get-items-dispatch="'getTrainers'"
                :item-name="['trainer', 'trainers']"
                :table-preferences-active="true"
                @emit-create="createTrainer"
            />
        </div>
    </div>
</template>

<script>
import ViewActions from '@/components/default/shared/ViewActions'
import TrainerListGrid from '@/components/ebs/trainers/list/TrainerListGrid'
import TrainerListTable from '@/components/ebs/trainers/list/TrainerListTable'
import { User } from '@/User'
import ComponentList from '@/components/default/shared/ComponentList'
import ComponentInductionMessage from '@/components/default/shared/ComponentInductionMessage'

export default {
  name: 'trainer-list',
  data () {
    return {
      user: new User(this.$store.getters.getAuthUserSecondStageTokenData),
      TrainerListTable,
      TrainerListGrid
    }
  },
  components: {
    ComponentInductionMessage,
    ComponentList,
    ViewActions
  },
  computed: {
    isSecondStageTokenFromOldLMS () {
      return this.$store.getters.getAuthUserIsSecondStageTokenOldLMS
    }
  },
  methods: {
    createTrainer () {
      this.$router.push({ name: 'ebs-trainer-add' })
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/trainers/trainerlist";
</style>
